import usePageTitle from '../hooks/usePageTitle';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthCallback: React.FC = () => {
  usePageTitle('Signing in');
  const [done, setDone] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const finishSignIn = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code);
        if (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to exchange auth callback code:', error);
          if (!cancelled) {
            setFailed(true);
            setDone(true);
          }
          return;
        }
      }

      const { data } = await supabase.auth.getSession();
      if (!cancelled) {
        setFailed(!data.session);
        setDone(true);
      }
    };

    finishSignIn();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!done) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          color: 'var(--text-secondary)',
        }}
      >
        Signing you in…
      </div>
    );
  }

  return <Navigate to={failed ? '/login' : '/'} replace />;
};

export default AuthCallback;
